const getDomain = () => {
  const { href, hostname } = window.location;
  const isLocalhost = href.includes('localhost:3000');
  const base = isLocalhost ? 'localhost:3000/' : `${hostname}/`;

  const parts = href.split(base);
  const domainPart = parts[1]?.split('/')[0];

  if (!domainPart || domainPart === '') {
    return null; // ou retorno padrão
  }

  return domainPart;
};

export default getDomain;
